import { sanitize } from 'isomorphic-dompurify';

const HTML_ENTITIES_TO_DECODE = [
  ['&lt;', '<'],
  ['&gt;', '>'],
  ['&amp;', '&'],
];

export const sanitizeScriptContent = (script: string): string => {
  const decodedContent = HTML_ENTITIES_TO_DECODE.reduce((content, [entity, value]) => {
    return content.replace(new RegExp(entity, 'gi'), value);
  }, sanitize(script));

  return decodedContent.replace(/<\/script/gi, '<\\/script');
};
